// arrow_back_ios
export const mdArrowBack = [
  '24, 24',
  '<path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"/><path d="M0 0h24v24H0z" fill="none"/>'
]
